import {
  UIRouter,
  ResolveTypes,
  Transition
} from '@uirouter/angular';

import { AuthService } from '../auth.service';

export function resolveAuthenticatedFn(transition: Transition, authService: AuthService, router: UIRouter) {
  return new Promise((resolve, reject) => {
    if (authService.currentUser) {
      resolve();
    } else {
      /**
       * @TODO
       * Find a better solution to auth redirects and returns to exclude the need of implementing anything
       * in the component of the state where the redirect goes.
       */
      router.stateService.go('main.home', {
        auth: {
          redirect: true,
          returnTo: transition.to().name
        }
      });

      reject('Unauthorized, please login');
    }
  });
}

export let resolveAuthenticated: ResolveTypes = {
  token: 'authenticated',
  deps: [Transition, AuthService, UIRouter],
  resolveFn: resolveAuthenticatedFn,
  policy: {async: 'WAIT'}
};



// WEBPACK FOOTER //
// ./src/app/auth/resolves/authenticated.resolve.ts